(() => {
  document.querySelectorAll('.section-listing-posts').forEach((root) => {
    const restBase  = root.dataset.rest;
    const endpoint  = root.dataset.endpoint || 'posts';
    const nonce     = root.dataset.nonce;
    
    const blogBase  = (root.dataset.blogBase || (location.origin + location.pathname)).replace(/#.*$/, '');
    
    const perPageInitial = parseInt(root.dataset.perPageInitial || '9', 10);
    const perPageMore    = parseInt(root.dataset.perPageMore    || '3', 10);

    const grid      = root.querySelector('.section-listing-posts__list__grid');
    const moreBtn   = root.querySelector('.section-listing-posts__list__more');
    const emptyMsg  = root.querySelector('.section-listing-posts__list__no-results');
    const selCategory = root.querySelector('.filter__select[data-filter="category"]');
    
    const nativeSelect = selCategory?.querySelector('.filter__select__native');
    const labelValue   = selCategory?.querySelector('.filter__select__value');
    const listEl       = selCategory?.querySelector('.filter__select__list');

    const cache = new Map();
    let offset = 0;
    let total  = 0;
    
    let catSlugToId = {};
    let catIdToSlug = {};
    let categoriesLoaded = false;

    const qs  = (sel, ctx = document) => ctx.querySelector(sel);
    const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

    const buildUrl = ({ perPage, offset, category }) => {
      const p = new URLSearchParams();
      p.set('per_page', String(perPage));
      p.set('offset',   String(offset));
      p.set('_embed',   '1');
      p.set('orderby',  'date');
      p.set('order',    'desc');
      if (category) p.set('categories', category);
      return `${restBase}/${endpoint}?${p.toString()}`;
    };

    // -------- Custom select (your same behavior) ----------
    function hydrateSelect(selectEl) {
      const btn    = qs('.filter__select__button', selectEl);
      const list   = qs('.filter__select__list',   selectEl);
      const value  = qs('.filter__select__value',  selectEl);
      const native = qs('.filter__select__native', selectEl);

      function open()  { selectEl.classList.add('is-open');  btn.setAttribute('aria-expanded','true');  list.setAttribute('aria-hidden','false'); }
      function close() { selectEl.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); list.setAttribute('aria-hidden','true'); }
      close();

      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const opened = selectEl.classList.contains('is-open');
        opened ? close() : open();
      });

      qsa('[role="option"]', list).forEach(li => {
        li.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          const val = li.dataset.value || '';
          if (native.value !== val) {
            native.value = val;
            value.textContent = li.textContent.trim();
            qsa('[role="option"]', list).forEach(o => o.setAttribute('aria-selected','false'));
            li.setAttribute('aria-selected','true');
            selectEl.dispatchEvent(new CustomEvent('dook:change', { bubbles: true }));
          }
          close();
        });
      });

      document.addEventListener('click', (e) => { if (!selectEl.contains(e.target)) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

      selectEl.addEventListener('keydown', (e) => {
        const opts = qsa('[role="option"]', list);
        const current = opts.findIndex(o => o.getAttribute('aria-selected') === 'true');
        if (e.key === 'ArrowDown') {
          e.preventDefault(); open();
          const next = Math.min(opts.length - 1, current + 1);
          opts.forEach(o => o.setAttribute('data-focus','0'));
          opts[next].setAttribute('data-focus','1'); opts[next].focus?.();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault(); open();
          const prev = Math.max(0, current - 1);
          opts.forEach(o => o.setAttribute('data-focus','0'));
          opts[prev].setAttribute('data-focus','1'); opts[prev].focus?.();
        } else if (e.key === 'Enter') {
          const foc = opts.find(o => o.getAttribute('data-focus') === '1') || opts[current];
          if (foc) foc.click();
        }
      });

      list.tabIndex = -1;
      btn.tabIndex  = 0;
    }
    hydrateSelect(selCategory);
    function setSelectValue(termIdOrEmpty) {
      if (!selCategory || !nativeSelect || !labelValue || !listEl) return;

      nativeSelect.value = termIdOrEmpty;
      const targetLi = qsa('[role="option"]', listEl).find(li => (li.dataset.value || '') === String(termIdOrEmpty));
      if (targetLi) {
        labelValue.textContent = targetLi.textContent.trim();
        qsa('[role="option"]', listEl).forEach(o => o.setAttribute('aria-selected','false'));
        targetLi.setAttribute('aria-selected','true');
      }
    }

    // -------- Fetch helpers ----------
    async function fetchJSON(url) {
      const res = await fetch(url, { headers: { 'X-WP-Nonce': nonce } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    }

    async function ensureCategories() {
      if (categoriesLoaded) return;
      const url = `${restBase}/categories?per_page=100&_fields=id,slug,name,link`;
      const cats = await fetchJSON(url);
      catSlugToId = {};
      catIdToSlug = {};
      cats.forEach(c => {
        catSlugToId[c.slug] = String(c.id);
        catIdToSlug[String(c.id)] = c.slug;
      });
      categoriesLoaded = true;
    }

    // -------- Data fetching ----------
    async function fetchPosts(url) {
      if (cache.has(url)) return cache.get(url);
      const res = await fetch(url, { headers: { 'X-WP-Nonce': nonce } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const totalAll = parseInt(res.headers.get('X-WP-Total') || '0', 10);
      const json = await res.json();
      const out = { json, totalAll };
      cache.set(url, out);
      return out;
    }

    function getAcfReadingMinutes(item) {
      const raw = item?.acf?.reading_time;
      if (raw == null) return null;
      const m = String(raw).match(/(\d+(?:[.,]\d+)?)/);
      if (!m) return null;
      const mins = Math.ceil(parseFloat(m[1].replace(',', '.')));
      return Number.isFinite(mins) && mins > 0 ? mins : null;
    }

    // -------- Cards ----------
    function card(item) {
      const titleRaw = item.title?.rendered || '';
      const titleTxt = titleRaw.replace(/<[^>]+>/g,'').trim();
      const title    = titleTxt.length > 60 ? titleTxt.slice(0,60) + '…' : titleTxt;
      const link     = item.link;

      const media = item._embedded?.['wp:featuredmedia']?.[0];
      const img   = media?.source_url || '';
      const alt   = media?.alt_text || title;

      const altAuthorRaw =
        (item.acf && item.acf.alternate_author) ??
        (item.meta && item.meta.alternate_author) ?? '';
      const altAuthor = typeof altAuthorRaw === 'string' ? altAuthorRaw.trim() : '';
      const author = altAuthor !== '' ? altAuthor : (item._embedded?.author?.[0]?.name || '');

      const dateISO = item.date_gmt ? new Date(item.date_gmt + 'Z').toISOString() : item.date;
      const dateHuman = new Date(dateISO).toLocaleDateString(undefined, { year:'numeric', month:'long', day:'numeric' });

      const cats = (item._embedded?.['wp:term']?.[0] || []).filter(t => t.taxonomy === 'category');
      const cat  = cats.find(c => c.id !== 1) || cats[0];
      const catSlug = cat ? (cat.slug || catIdToSlug[String(cat.id)] || '') : '';
      const catUrl  = catSlug ? `${blogBase.replace(/\/?$/, '/') }#${catSlug}` : '';
      const catHtml = (cat && catUrl) ? `<a href="${catUrl}" class="post-teaser__cat">${cat.name}</a>` : '';

      const rawExcerpt = (item.excerpt?.rendered || '').replace(/<[^>]+>/g,'').trim();
      const excerpt = rawExcerpt.length > 105 ? rawExcerpt.slice(0,105) + '…' : rawExcerpt;

      const tReadMore = root?.dataset?.readMore || 'Read more';
      const minsAcf = getAcfReadingMinutes(item);

      const readingTimeRaw =
        (item.acf && item.acf.reading_time) ??
        (item.meta && item.meta.reading_time) ?? '';
      const readingTime = typeof readingTimeRaw === 'string' ? readingTimeRaw.trim() : '';

      return `
        <li>
          <article class="post-teaser">
            <figure class="post-teaser__image">
              <a href="${link}" class="post-teaser__thumb" aria-label="${tReadMore}: ${title}">
                ${img ? `<img src="${img}" alt="${alt ? alt.replace(/"/g,'&quot;') : ''}" loading="lazy" decoding="async">` : ''}
              </a>
            </figure>
            <div class="post-teaser__content">
              <ul class="post-teaser__content__info body-regular-7">
                <li>${catHtml}</li>
                ${readingTime ? `<li><span>~ ${readingTime}</span></li>` : ``}
              </ul>

              <h3 class="post-teaser__content__title body-semibold-3">
                <a href="${link}" aria-label="${tReadMore}: ${title}">${title}</a>
              </h3>
              ${excerpt ? `<p class="post-teaser__content__excerpt body-regular-5">${excerpt}</p>` : ''}

              <div class="post-teaser__content__meta body-regular-6">
                ${author ? `<span>${author}</span>` : ''}
                <time datetime="${dateISO}">${dateHuman}</time>
              </div>

              <a href="${link}" class="btn btn--v7" aria-label="${tReadMore}: ${title}">
                <span class="body-semibold-5">${tReadMore}</span>
              </a>
            </div>
          </article>
        </li>
      `;
    }

    // -------- Loading logic ----------
    async function load({ reset=false } = {}) {
      emptyMsg.hidden = true;

      const categoryTermId = nativeSelect ? (nativeSelect.value || '') : '';
      const batch    = reset ? perPageInitial : perPageMore;
      const url      = buildUrl({ perPage: batch, offset, category: categoryTermId || undefined });

      root.classList.add('is-loading');

      try {
        const { json, totalAll } = await fetchPosts(url);
        total = totalAll;

        if (reset) grid.innerHTML = '';

        if (!json.length && offset === 0) {
          emptyMsg.hidden = false;
          moreBtn.hidden = true;
          return;
        }

        grid.insertAdjacentHTML('beforeend', json.map(card).join(''));

        offset += batch;

        const hasMore = offset < total;
        moreBtn.hidden = !hasMore;
      } catch (err) {
        console.error(err);
        if (reset) grid.innerHTML = '';
        emptyMsg.hidden = false;
        moreBtn.hidden = true;
      } finally {
        root.classList.remove('is-loading');
      }
    }

    function onFilterChange() {
      const termId = nativeSelect.value || '';
      const slug = termId ? (catIdToSlug[String(termId)] || '') : '';
      if (slug) {
        history.replaceState(null, '', `${blogBase}#${slug}`);
      } else {
        history.replaceState(null, '', blogBase);
      }

      offset = 0;
      load({ reset: true });
    }
    selCategory.addEventListener('dook:change', onFilterChange);

    moreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      load({ reset: false });
    });

    // -------- Initial boot: ensure cats, sync from hash, load ----------
    async function boot() {
      try {
        await ensureCategories();

        const hashSlug = (location.hash || '').replace(/^#/, '').trim();
        if (hashSlug && catSlugToId[hashSlug]) {
          const termId = catSlugToId[hashSlug];
          setSelectValue(termId);
        } else {
          setSelectValue('');
        }

        offset = 0;
        await load({ reset: true });

        window.addEventListener('hashchange', () => {
          const slug = (location.hash || '').replace(/^#/, '').trim();
          const termId = slug && catSlugToId[slug] ? catSlugToId[slug] : '';
          if ((nativeSelect.value || '') !== String(termId)) {
            setSelectValue(termId);
            offset = 0;
            load({ reset: true });
          }
        });
      } catch (e) {
        console.error('Boot error:', e);
        offset = 0;
        load({ reset: true });
      }
    }

    boot();
  });
})();
